import styling from "Services/styling";

export default {
	wrapper: {
		position: "relative",
	},
	backgroundColor: styling.colors.modalBackground,
};
